import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorPageComponent } from './components/pages/error-page/error-page.component';
import { CaseStudiesThreeColumnsPageComponent } from './components/pages/case-studies-three-columns-page/case-studies-three-columns-page.component';
import { HomepageOneComponent } from './components/pages/homepage-one/homepage-one.component';
import { AboutPageComponent } from './components/pages/about-page/about-page.component';
import { CaseStudiesDetailsPageComponent } from './components/pages/case-studies-details-page/case-studies-details-page.component';
import { FaqPageComponent } from './components/pages/faq-page/faq-page.component';
import { ServicesDetailsFactomesComponent } from './services-details-factomes/services-details-factomes.component';
import { InductiveDetailsComponent } from './components/pages/homepage-one/inductive-details/inductive-details.component';
import { AWSComponent } from './components/pages/homepage-one/aws/aws.component';

import { Testimonialcase2Component } from './components/pages/testimonialcase2/testimonialcase2.component';
import { Testimonialcase3Component } from './components/pages/testimonialcase3/testimonialcase3.component';
import { Testimonialcase4Component } from './components/pages/testimonialcase4/testimonialcase4.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsComponent } from './terms/terms.component';
import { Testing2Component } from './testing2/testing2.component';

import { BasicComponent } from './basic/basic.component';
import { InterimediateComponent } from './interimediate/interimediate.component';
import { AdvanceComponent } from './advance/advance.component';
import { AddOnServiceComponent } from './add-on-service/add-on-service.component';
import { BookDemoPageComponent } from './components/book-demo-page/book-demo-page.component';
import { TryitnowComponent } from './components/tryitnow/tryitnow.component';
import { LandingPageNewComponent } from './components/landing-page-new/landing-page-new.component';
import { ServiceDetailsFactoplanComponent } from './components/pages/service-details-factoplan/service-details-factoplan.component';
import { ThankYouComponent } from './components/layouts/thank-you/thank-you.component';
import { ServiceDetailsFactoVisionComponent } from './components/pages/service-details-facto-vision/service-details-facto-vision.component';
import { ServiceDetailsFactoLakeComponent } from './components/pages/service-details-facto-lake/service-details-facto-lake.component';
import { ServiceDetailsFactoIQComponent } from './components/pages/service-details-facto-iq/service-details-facto-iq.component';
import { SCADALandingPageComponent } from './scadalanding-page/scadalanding-page.component';
const routes: Routes = [
    {path: '', component: HomepageOneComponent},
    {path: 'Overview', component: AboutPageComponent},
    {path: 'Client-Testimonials', component: CaseStudiesThreeColumnsPageComponent},
    {path: 'testimonialcase1', component: CaseStudiesDetailsPageComponent},
    {path: 'error', component: ErrorPageComponent},
    {path: 'faq', component: FaqPageComponent},
    {path: 'FactoMES',component:ServicesDetailsFactomesComponent},
    {path:'inductive-details',component:InductiveDetailsComponent},
    {path:'aws',component:AWSComponent},
    {path:'testimonialcase2',component:Testimonialcase2Component},
    {path:'testimonialcase3',component:Testimonialcase3Component},
    {path:'testimonialcase4',component:Testimonialcase4Component},
    {path:'privacy&policy',component:PrivacyComponent},
    {path:'Terms&Condition',component:TermsComponent},
    {path:'Testing2',component:Testing2Component},
    {path:'Basic',component:BasicComponent},
    {path:'intermediate',component:InterimediateComponent},
    {path:'Advanced',component:AdvanceComponent},
    {path:'Add-on-service',component:AddOnServiceComponent},
    {path:'BookDemo',component:BookDemoPageComponent},
    {path:'TryItNow',component:TryitnowComponent},
    {path:'Solution',component:LandingPageNewComponent},
    {path:'FactoPlan',component:ServiceDetailsFactoplanComponent},
    {path:'FactoVision',component:ServiceDetailsFactoVisionComponent},
    {path:'ThankYou',component:ThankYouComponent},
    {path:'FactoLake',component:ServiceDetailsFactoLakeComponent},
    {path:'FactoIQ',component:ServiceDetailsFactoIQComponent},
    {path:'Scada',component:SCADALandingPageComponent},




    
    
    {path: '**', component: ErrorPageComponent} // This line will remain down from the whole component list
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }